import { CellProps } from '@/components/bulkQueue/types';
import { VisitActionsCell } from '@/components/visits/tables/VisitActionsCell';
import { FC } from 'react';

export const ActionsRenderCell: FC<CellProps> = (props) => {
    const { entity } = props;

    switch (entity.__typename) {
        case 'Visit':
            return <VisitActionsCell visitId={entity.id} />;
        default:
            return null;
    }
};
